export default "__VITE_ASSET__dd99169c__"